import {APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
// import {apiInterceptor} from './core/interceptors/api.interceptor';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';

import { apiInterceptor, authInterceptor, BACKEND_URL, ConfigService, initializeAppInEnvFromConf } from 'shared-frontend';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(), // Angular Material
    provideHttpClient(
      withInterceptors([apiInterceptor, authInterceptor]) // Register interceptors. Interceptors run in the order they're registered.
    ), 
    // { provide: BACKEND_URL, useValue: environment.backendUrl }, // If it's static & comes from the env files
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppInEnvFromConf(environment.environmentName),
      deps: [ConfigService],
      multi: true
    },
    {
      provide: BACKEND_URL,
      useFactory: (configService: ConfigService) => configService.backendUrl,
      deps: [ConfigService]
    },
    provideRouter(routes),
    provideZoneChangeDetection({ eventCoalescing: true })
  ]
};
